import { render, staticRenderFns } from "./SpecialistsCatalog.vue?vue&type=template&id=0d0e8579"
import script from "./SpecialistsCatalog.vue?vue&type=script&lang=js"
export * from "./SpecialistsCatalog.vue?vue&type=script&lang=js"
import style0 from "./SpecialistsCatalog.vue?vue&type=style&index=0&id=0d0e8579&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports